module.exports = __webpack_public_path__ + "img/2.e75d154c.png";